<template>
	<div
		class="component c-stories padding-y-24 bp-768:padding-y-48"
		:class="{ dark: section.dark_mode }"
		v-bind:style="{
			'background-image': 'url(' + section.backgroundImage + ') ',
		}"
	>
		<div class=" row padding-x-12">
			<common-header
				:headline="section.headline"
				:sponsor="section.sponsor"
			/>
		</div>
		<div class=" row padding-x-12">
			<div
				class=" flex-item-1 s-common__interactions c-stories__interactions d-flex justify-content-between"
			>
				<div class="s-common__filter c-stories__filters">
					<button
						class="s-common__filter-button c-stories__filter-button font-size-14 line-height-125"
						:class="{ 'is-active': active_filter === 'featured' }"
						@click="filter_players('featured')"
					>
						Featured
					</button>
					<button
						class="s-common__filter-button c-stories__filter-button font-size-14 line-height-125"
						:class="{
							'is-active': active_filter === 'latest',
						}"
						@click="filter_players('latest')"
					>
						Latest
					</button>
				</div>
				<div class="s-common__tabs c-stories__tabs align-self-center">
					<button
						class="s-common__tab c-stories__tab font-size-14 line-height-150"
						:class="{
							'is-active': active_view === 'list',
						}"
						@click="change_view('list')"
					>
						<div
							class="s-common__tab--dot c-stories__tab--dot"
						></div>
						<span
							>List
							<span class="d-none bp-540:d-inline"
								>View</span
							></span
						>
					</button>
					<button
						class="s-common__tab c-stories__tab font-size-14 line-height-150"
						:class="{
							'is-active': active_view === 'cards',
						}"
						@click="change_view('cards')"
					>
						<div
							class="s-common__tab--dot c-stories__tab--dot"
						></div>
						<span
							>Card
							<span class="d-none bp-540:d-inline"
								>View</span
							></span
						>
					</button>
				</div>
			</div>
		</div>
		<div class="c-stories__content padding-y-6 row">
			<div class="width-100" v-show="active_filter === 'featured'">
				<div
					v-show="active_view === 'cards'"
					class=" padding-x-6  c-stories__card"
				>
					<div class="flex-item-1 row" v-if="section.stories">
						<div
							v-for="story in section.stories.slice(0, 6)"
							:key="story.id"
							class="c-stories__card--item d-flex padding-6 width-100 bp-768:width-50 bp-1024:width-33 bp-1280:width-25 "
						>
							<div
								class="c-stories__card--item-inside flex-item-1"
							>
								<div
									class="c-stories__card--item-image-container"
								>
									<div
										v-if="story.image"
										class="c-stories__card--item-image"
										v-bind:style="{
											'background-image':
												'url(' +
												story.image +
												'?width=768) ',
										}"
									></div>
								</div>
								<div
									class="c-stories__card--item-details d-flex flex-direction-column"
								>
									<h3
										v-if="story.headline"
										class="c-stories__card--item-title font-size-21 line-height-125 font-weight-700"
									>
										<a
											class="c-stories__card--item-url"
											v-bind:href="story.url"
											>{{ story.headline }}</a
										>
									</h3>
									<div
										v-if="story.teaser"
										v-html="story.teaser"
										class="c-stories__card--item-teaser flex-item-1 font-size-14 line-height-150"
									></div>
									<a
										class="c-stories__card--item-more font-weight-700 font-size-12 line-height-125"
										v-bind:href="story.url"
										>Full Story</a
									>
								</div>
							</div>
						</div>
					</div>
				</div>
				<div
					v-show="active_view === 'list'"
					class=" padding-x-12 margin-y-6 c-stories__list"
				>
					<div v-if="section.stories">
						<div
							v-for="story in section.stories.slice(0, 6)"
							:key="story.id"
							class="c-stories__list--item d-flex "
						>
							<div
								class="c-stories__list--item-inside d-flex flex-item-1"
							>
								<div
									class="c-stories__list--item-image-container"
								>
									<div
										v-if="story.image"
										class="c-stories__list--item-image"
										v-bind:style="{
											'background-image':
												'url(' +
												story.image +
												'?width=768) ',
										}"
									></div>
								</div>
								<div
									class="c-stories__list--item-details flex-item-1 d-flex justify-content-center flex-direction-column"
								>
									<h3
										v-if="story.headline"
										class="c-stories__list--item-title font-size-21 line-height-125 font-weight-700"
									>
										<a
											class="c-stories__list--item-url"
											v-bind:href="story.url"
											>{{ story.headline }}</a
										>
									</h3>
									<div
										v-if="story.teaser"
										v-html="story.teaser"
										class="c-stories__list--item-teaser font-size-14 line-height-150"
									></div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
			<div class="width-100" v-show="active_filter === 'latest'">
				<div
					v-show="active_view === 'cards'"
					class="padding-x-6   c-stories__card"
				>
					<div class="flex-item-1 row" v-if="latest_stories">
						<div
							v-for="story in latest_stories"
							:key="story.story_id"
							class="c-stories__card--item d-flex padding-6 width-100 bp-768:width-50 bp-1024:width-33 bp-1280:width-25 "
						>
							<div
								class="c-stories__card--item-inside flex-item-1"
							>
								<div
									class="c-stories__card--item-image-container "
								>
									<div
										v-if="story.story_image"
										class="c-stories__card--item-image"
										v-bind:style="{
											'background-image':
												'url(' +
												story.story_image +
												'?width=768) ',
										}"
									></div>
								</div>
								<div
									class="c-stories__card--item-details d-flex flex-direction-column"
								>
									<h3
										v-if="story.story_headline"
										class="c-stories__card--item-title font-size-21 line-height-125 font-weight-700"
									>
										<a
											class="c-stories__card--item-url"
											v-bind:href="story.story_path"
											>{{ story.story_headline }}</a
										>
									</h3>
									<div
										v-if="story.story_summary"
										v-html="story.story_summary"
										class="c-stories__card--item-teaser flex-item-1 font-size-14 line-height-150"
									></div>
									<a
										class="c-stories__card--item-more font-weight-700 font-size-12 line-height-125"
										v-bind:href="story.story_path"
										>Full Story</a
									>
								</div>
							</div>
						</div>
					</div>
				</div>
				<div
					v-show="active_view === 'list'"
					class="padding-x-12 margin-y-6 c-stories__list"
				>
					<div v-if="latest_stories">
						<div
							v-for="story in latest_stories"
							:key="story.story_id"
							class="c-stories__list--item d-flex "
						>
							<div
								class="c-stories__list--item-inside d-flex flex-item-1"
							>
								<div
									class="c-stories__list--item-image-container"
								>
									<div
										v-if="story.story_image"
										class="c-stories__list--item-image"
										v-bind:style="{
											'background-image':
												'url(' +
												story.story_image +
												'?width=768) ',
										}"
									></div>
								</div>
								<div
									class="c-stories__list--item-details d-flex justify-content-center flex-direction-column"
								>
									<h3
										v-if="story.story_headline"
										class="c-stories__list--item-title font-size-21 line-height-125 font-weight-700"
									>
										<a
											class="c-stories__list--item-url"
											v-bind:href="story.story_path"
											>{{ story.story_headline }}</a
										>
									</h3>
									<div
										v-if="story.story_summary"
										v-html="story.story_summary"
										class="c-stories__list--item-teaser  font-size-14 line-height-150"
									></div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
		<div class="row padding-x-24 margin-t-12">
			<a
				class="s-common__button c-stories__more font-size-14 line-height-125 font-weight-700"
				:href="'/archives?path=' + $root.signing_day.sport.shortname"
				>View All Stories</a
			>
		</div>
	</div>
</template>

<script>
import SectionBase from './SectionBase';
import Client from '@/client';
import CommonHeader from '@/components/common/CommonHeader.vue';
import { should_use_v2_api } from '@/helpers';
export default {
	extends: SectionBase,
	name: 'SectionStories',
	components: { CommonHeader },
	data: () => ({
		active_view: 'cards',
		active_filter: 'featured',
		latest_stories: null,
	}),
	methods: {
		change_view(view) {
			this.active_view = view;
		},
		filter_players(filter) {
			this.active_filter = filter;
		},
		get_latest_stories() {
			if (should_use_v2_api()) {
				this.fetch_stories_from_v2_api();
			} else {
				this.fetch_stories_from_legacy_api();
			}
		},
		fetch_stories_from_legacy_api() {
			Client.get(
				'/services/archives.ashx/stories?index=1&page_size=6&season=0&search=',
				{
					params: {
						sport: this.$root.signing_day.sport.shortname,
					},
					headers: {
						'Access-Control-Allow-Origin': '*',
						'Content-type': 'application/json',
					},
				},
			).then(response => {
				if (response && response.data && response.data.data) {
					this.latest_stories = response.data.data;
				}
			});
		},
		fetch_stories_from_v2_api() {
			Client.get(
				`/api/v2/Archives?$pageIndex=1&$pageSize=6&sportId=${this.$root.signing_day.sport.id}`,
			).then(response => {
				if (
					response &&
					response.data &&
					response.data.items != null &&
					response.data.items.length > 0
				) {
					this.latest_stories = this.map_v2_response(
						response.data.items,
					);
				}
			});
		},
		map_v2_response(data) {
			return data.map(x => ({
				story_id: x.storyId,
				story_rank: x.storyRank,
				story_title: x.storyTitle,
				story_image: x.storyImage,
				image_alt_text: '', // To-do: add story image alt text to v2 API response
				story_headline: x.storyHeadline,
				story_summary: x.storySummary,
				story_postdate: x.storyPostdate,
				story_created: x.storyCreated,
				story_filename: x.storyFilename,
				story_path: x.storyPath,
				sportsCats: x.sportsCats,
			}));
		},
	},
	created() {
		this.get_latest_stories();
	},
};
</script>

<style scoped lang="scss">
.c-stories {
	&__card {
		&--item {
			&-inside {
				color: $main-font-color;
				background: $main-color;
				border: 1px solid $main-border-color;
				box-sizing: border-box;
				border-radius: 10px;
				overflow: hidden;
				display: flex;
				flex-direction: column;
			}
			&-details {
				padding: 24px;
				flex: 1;
			}
			&-more {
				display: block;
				width: 122px;
				display: flex;
				align-items: center;
				text-transform: uppercase;
				justify-content: center;
				height: 35px;
				color: var(--text-on-primary);
				background: var(--color-primary);
				text-decoration: none;
				margin-top: auto;
				&:hover {
					transition: 0.25s;
				}
			}
			&-teaser {
				margin: 0 0 24px 0;

				a {
					color: $main-font-color;
				}
			}
			&-image-container {
				flex-shrink: 0;
			}
			&-image {
				height: 0;
				padding-bottom: 56.25%;
				width: 100%;
				overflow: hidden;
				background-size: cover;
				background-position: top center;
			}
			&-title {
				margin: 0 0 12px 0;
				padding-top: 15px;
				position: relative;
				color: $main-font-color;
				&:before {
					content: '';
					display: block;
					width: 60px;
					height: 3px;
					position: absolute;
					top: 0;
					left: 0;
					background: var(--color-primary);
				}
			}
			&-url {
				text-decoration: none;
				&:hover {
					text-decoration: underline;
				}
			}
			&:nth-child(1),
			&:nth-child(2) {
				width: 50% !important;
				.c-stories__card--item {
					&-inside {
						display: flex;
						flex-direction: row;
					}
					&-details {
						width: 50%;
					}
					&-image-container {
						width: 50%;
					}
					&-image {
						height: 0;
						padding-bottom: 114.94252287%;
						width: 100%;
						overflow: hidden;
						background-size: cover;
						background-position: top center;
					}
				}
				@media screen and (max-width: 1279px) {
					.c-stories__card--item {
						&-inside {
							flex-direction: column;
						}
						&-teaser {
							margin: 0 0 24px 0;
							a {
								color: $main-font-color;
							}
						}
						&-details {
							width: auto;
						}
						&-image-container {
							flex-shrink: 0;
							width: auto;
						}
						&-image {
							height: 0;
							padding-bottom: 56.25%;
							width: 100%;
							overflow: hidden;
							background-size: cover;
							background-position: top center;
						}
					}
				}
				@media screen and (max-width: 767px) {
					width: 100% !important;
				}
			}
		}
	}
	&__list {
		&--item {
			margin: 0 0 12px 0;
			&:last-child {
				margin: 0;
			}
			&-inside {
				flex: 1;
				position: relative;
				color: $main-font-color;
				background: $main-color;
				border: 1px solid $main-border-color;
				box-sizing: border-box;
				border-radius: 10px;
				overflow: hidden;
				min-height: 190px;
			}
			&-details {
				padding: 24px;
				flex: 1;
			}
			&-more {
				display: block;
				width: 122px;
				display: flex;
				align-items: center;
				text-transform: uppercase;
				justify-content: center;
				height: 35px;
				color: var(--text-on-primary);
				background: var(--color-primary);
				text-decoration: none;
				margin-top: auto;
				&:hover {
					transition: 0.25s;
				}
			}
			&-teaser {
				a {
					color: $main-font-color;
				}
			}
			&-image-container {
				flex-shrink: 0;
				width: 336px;
			}
			&-image {
				height: 100%;
				width: 100%;
				overflow: hidden;
				background-size: cover;
				background-position: top center;
			}
			&-title {
				margin: 0 0 12px 0;
				padding-top: 15px;
				position: relative;
				color: $main-font-color;
				&:before {
					content: '';
					display: block;
					width: 60px;
					height: 3px;
					position: absolute;
					top: 0;
					left: 0;
					background: var(--color-primary);
				}
			}
			&-url {
				text-decoration: none;
				&:hover {
					text-decoration: underline;
				}
			}

			@media screen and (max-width: 767px) {
				&-inside {
					min-height: auto;
				}
				&-image-container {
					display: none;
				}
			}
		}
	}
}
</style>
<style lang="scss">
[data-theme='dark'] {
	.c-stories {
		&__list {
			&--item {
				&-inside {
					background: #0d0d0d;
				}
			}
		}
	}
}

.dark.c-stories {
}
</style>
